import { gql } from '@apollo/client';
import type {
  ImportBatchResponse,
  ImportFuelTransactionsBatchInput,
  ValidateFuelTransactionsImportInput,
  ValidateFuelTransactionsImportResponse,
} from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLFuelCardRequester {
  public validateFuelTransactionsImport = (input: ValidateFuelTransactionsImportInput): Promise<ValidateFuelTransactionsImportResponse> =>
    graphQLRequester
      .query<{
        validateFuelTransactionsImport: ValidateFuelTransactionsImportResponse;
      }>({
        query: gql`
          query ValidateFuelTransactionsImport($input: ValidateFuelTransactionsImportInput!) {
            validateFuelTransactionsImport(input: $input) {
              validRows {
                licensePlate
                transactionTime
                odometerInKm
                fuelType
                quantityInLiters
                totalCost
                merchant {
                  cnpj
                  name
                  city
                  state
                }
              }
              invalidRows {
                data {
                  licensePlate
                  transactionTime
                  odometer
                  fuelType
                  quantityInLiters
                  totalCost
                  merchantName
                  merchantCnpj
                  merchantCity
                  merchantState
                  rowIndex
                }
                errors {
                  error
                  column {
                    name
                    position
                  }
                }
              }
            }
          }
        `,
        variables: {
          input,
        },
      })
      .then((response) => response.validateFuelTransactionsImport);

  public importFuelTransactions = (input: ImportFuelTransactionsBatchInput[]): Promise<ImportBatchResponse> =>
    graphQLRequester
      .mutate<{ createdTransactions: ImportBatchResponse }, { input: ImportFuelTransactionsBatchInput[] }>({
        mutation: gql`
          mutation ImportFuelTransactions($input: [ImportFuelTransactionsBatchInput!]!) {
            importFuelTransactions(input: $input) {
              count
            }
          }
        `,
        variables: {
          input,
        },
      })
      .then((response) => response.createdTransactions);
}

export default GraphQLFuelCardRequester;
